<template>
  <div>
  <b-container fluid class="p-0 m-0">
    <b-carousel
      id="carousel"
      controls
      img-height="500"
      indicators>
    <b-carousel-slide
      caption="¿Es un profesional de la salud?"
      text="Da a conocer tu servicios a cientos de potenciales clientes de una manera rápida e inteligente a travez de nuestra plataforma. Por medio de la geolocalización nos encargamos de acercarte a potenciales clientes."
      img-src="https://s3.amazonaws.com/assets.listadomedico.com/images/slides/slide-1.png" img-height="500" />
    <b-carousel-slide
      caption="Alexa lo acerca a nuevo segmento de usuarios."
      text="Los asistentes virtuales toman cada vez más popularidad en los hogares. A travez de nuestra plataforma usted podrá llegar a miles de usuarios de Amazon Alexa en todo México."
      img-src="https://s3.amazonaws.com/assets.listadomedico.com/images/slides/slide-2.png" img-height="500" />
    </b-carousel>
  </b-container>
  <b-container fluid class="p-0 m-0 bg-white">
    <b-container class="py-5">
      <b-row>
        <b-col xl="12">
          <b-tabs active-nav-item-class="bg-light" content-class="p-3 bg-light">
            <b-tab title="Médicos" active>
              <b-form @submit="onSubmitDoctorSearch">
                <b-form-row>
                  <b-col md="5">
                    <b-form-input
                      id="d-address"
                      v-model="doctorForm.data.address"
                      type="text"
                      required
                      size="lg"
                      placeholder="Ingrese una dirección" />
                  </b-col>
                  <b-col md="4">
                    <b-form-select
                      id="d-speciality"
                      v-model="doctorForm.data.speciality"
                      :options="doctorForm.metadata.specialities"
                      size="lg"
                      required>
                      <template v-slot:first>
                        <option :value="null" disabled>Seleccione una especialidad</option>
                      </template>
                    </b-form-select>
                  </b-col>
                  <b-col md="2">
                    <b-form-select
                      id="d-distance"
                      v-model="doctorForm.data.distance"
                      :options="doctorForm.metadata.distances"
                      size="lg"
                      required />
                  </b-col>
                  <b-col md="1">
                    <b-button type="submit" block variant="primary" size="lg">
                      <font-awesome-icon :icon="['fas','search']"/>
                    </b-button>
                  </b-col>
                </b-form-row>
              </b-form>
            </b-tab>
            <b-tab title="Hospitales">
              <b-form @submit="onSubmitHospitalSearch">
                <b-form-row>
                  <b-col md="7">
                    <b-form-input
                      id="h-address"
                      v-model="hospitalForm.data.address"
                      type="text"
                      required
                      size="lg"
                      placeholder="Ingrese una dirección" />
                  </b-col>
                  <b-col md="2">
                    <b-form-select
                      id="h-kind"
                      v-model="hospitalForm.data.kind"
                      :options="hospitalForm.metadata.kind"
                      size="lg"
                      required>
                    </b-form-select>
                  </b-col>
                  <b-col md="2">
                    <b-form-select
                      id="h-distance"
                      v-model="hospitalForm.data.distance"
                      :options="hospitalForm.metadata.distances"
                      size="lg"
                      required>
                    </b-form-select>
                  </b-col>
                  <b-col md="1">
                    <b-button type="submit" block variant="primary" size="lg">
                      <font-awesome-icon :icon="['fas','search']"/>
                    </b-button>
                  </b-col>
                </b-form-row>
              </b-form>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col xl="12">
          <adsense
            ad-slot="9585150092"
            ad-format="auto"
            :ad-client="adsenseClient"
            ad-style="display:block">
          </adsense>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
  <b-container fluid class="bg-light">
    <b-container class="py-3">
      <b-row>
        <b-col xl="12">
          <b-card-group deck>
            <b-card
              img-src="https://s3.amazonaws.com/assets.listadomedico.com/images/medic-profile.jpg"
              body-class="text-center"
              img-alt="Perfil"
              img-width=140
              img-top>
              <h5 class="card-title text-muted">Perfiles médicos</h5>
              <p class="card-text">Consulta el perfil profesional de cada médico antes de reservar tu cita médica. Te dará una mejor perspectiva de la asesoría que buscas.</p>
            </b-card>
            <b-card
              img-src="https://s3.amazonaws.com/assets.listadomedico.com/images/schedule-medic.jpg"
              img-alt="Citas médicas online"
              body-class="text-center"
              img-width=140
              img-top>
              <h5 class="card-title text-muted">Citas médicas online</h5>
              <p class="card-text">Puedes reservar citas médicas desde el perfil del médico con unos cuantos clicks, o si lo prefieres siempre podrás hacerlo por teléfono.</p>
            </b-card>
            <b-card
              img-src="https://s3.amazonaws.com/assets.listadomedico.com/images/amazon-alexa.jpg"
              body-class="text-center"
              img-alt="Perfil"
              img-width=140
              img-top>
              <h5 class="card-title text-muted">Busca desde Alexa</h5>
              <p class="card-text">Instala nuestra skill Listado Médico desde la <a href="https://www.amazon.com.mx/Picharras-Listado-M%C3%A9dico/dp/B07Q4R3QRP">tienda de skills de Alexa</a> y encuentra médicos utilizando solamente tu voz.</p>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
  <!-- <b-container fluid class="p-0 m-0">
    <b-container class="py-4">
      <b-row>
        <b-col xl="12">
          <h3 class="text-primary text-center">Lo que nuestros usuarios opinan</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="12">
          <b-carousel id="carousel-testimonials"
            controls
            indicators>
            <b-carousel-slide caption="Este texto es caption" img-blank img-alt="" img-width="0" img-height="0">
              <blockquote class="blockquote">
                <p class="mb-0 small">Soy nueva en la ciudad y Listado Médico me ayudó a encontrar un excelente dentista para completar mi tratamiento.</p>
                <footer class="blockquote-footer small">Pamela Molina.
                  <cite title="Ciudad">Ciudad de México, CDMX</cite>
                </footer>
              </blockquote>
            </b-carousel-slide>
          </b-carousel>
        </b-col>
      </b-row>
    </b-container>
  </b-container> -->
</div>
</template>

<script>
import Adsense from '@/components/Adsense'

export default {
  name: 'Home',
  components: { Adsense },
  data () {
    return {
      DAutocomplete: null,
      HAutocomplete: null,
      adsenseClient: process.env.VUE_APP_GOOGLE_ADSENSE_CLIENT,
      doctorForm: {
        data: {
          address: null,
          latitude: null,
          longitude: null,
          distance: 3,
          speciality: null
        },
        metadata: {
          distances: [],
          specialities: []
        }
      },
      hospitalForm: {
        data: {
          kind: 'all',
          address: null,
          latitude: null,
          longitude: null,
          distance: 3
        },
        metadata: {
          kind: [
            { value: 'all', text: 'Todos' },
            { value: 'public', text: 'Públicos' },
            { value: 'private', text: 'Privados' }
          ],
          distances: [],
          specialities: []
        }
      }
    }
  },
  mounted: async function () {
    const catalogs = await this.$http.get('/catalogs')
    this.doctorForm.metadata.specialities = catalogs.data.specialities
    this.doctorForm.metadata.distances = catalogs.data.distances

    this.hospitalForm.metadata.distances = catalogs.data.distances
    const options = { types: ['geocode'] }
    this.DAutocomplete = new window.google.maps.places
      .Autocomplete(document.getElementById('d-address'), options)
    this.DAutocomplete.addListener('place_changed', this.onDoctorPlaceChanged)

    this.HAutocomplete = new window.google.maps.places
      .Autocomplete(document.getElementById('h-address'), options)
    this.HAutocomplete.addListener('place_changed', this.onHospitalPlaceChanged)
  },
  methods: {
    onDoctorPlaceChanged () {
      const place = this.DAutocomplete.getPlace()
      this.doctorForm.data.address = place.formatted_address
      this.doctorForm.data.latitude = place.geometry.location.lat()
      this.doctorForm.data.longitude = place.geometry.location.lng()
    },
    onHospitalPlaceChanged () {
      const place = this.HAutocomplete.getPlace()
      this.hospitalForm.data.address = place.formatted_address
      this.hospitalForm.data.latitude = place.geometry.location.lat()
      this.hospitalForm.data.longitude = place.geometry.location.lng()
    },
    onSubmitDoctorSearch (event) {
      event.preventDefault()
      this.$router.push({
        name: 'Doctors',
        params: this.doctorForm.data,
        query: this.doctorForm.data
      })
    },
    onSubmitHospitalSearch (event) {
      event.preventDefault()
      this.$router.push({
        name: 'Hospitals',
        params: this.hospitalForm.data,
        query: this.hospitalForm.data
      })
    }
  }
}
</script>

<style>
.carousel-item {
  height: 60vh;
  min-height: 300px;
  background: no-repeat center center scroll;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>
